import { render, staticRenderFns } from "./CoozzySuccessPendingIcon.vue?vue&type=template&id=5bee4a1c&scoped=true"
import script from "./CoozzySuccessPendingIcon.vue?vue&type=script&lang=js"
export * from "./CoozzySuccessPendingIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzySuccessPendingIcon.vue?vue&type=style&index=0&id=5bee4a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bee4a1c",
  null
  
)

export default component.exports